export default "__VITE_ASSET__BdzvXyt5__"